module.exports = __webpack_public_path__ + "static/img/total_solar_radiation.4b2919a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/total_solar_radiation.png
// module id = UBSz
// module chunks = 1